import { AdditionalSearchType } from '@upright/common/model/search/types';
import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';
import styled from 'styled-components';
import { FeatureId } from '../../../../../../../../../../common/iam/access/feature-access/types';
import { ModelEntityType } from '../../../../../../../../../../common/model/input/types';
import { getTextStyle } from '../../../../../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../../../../../generic/global/bou-colors';
import { useHasAccessToFeature, useIsTeam } from '../../../../../../../../generic/hooks';
import { FilterRadioButton } from './filter-radio-button';
import { Props } from './types';

export function FiltersBlock(props: Props) {
  const canSeeProducts = useHasAccessToFeature(FeatureId.PRODUCT_SEARCH);
  const isTeam = useIsTeam();
  const canSeeMixins = isTeam;
  const canSeePhenomena = isTeam;
  const canSeeLegalEntities = isTeam;

  return (
    <Root>
      <Main>
        <SearchFor>Search for</SearchFor>
        <ButtonsPart>
          <FilterRadioButton {...props} type={AdditionalSearchType.ALL} text="Everything" />
          {canSeeProducts && <FilterRadioButton {...props} type={ModelEntityType.PRODUCT} text="Products" />}
          {canSeeMixins && <FilterRadioButton {...props} type={ModelEntityType.MIXIN} text="Mixins" />}
          {canSeePhenomena && <FilterRadioButton {...props} type={ModelEntityType.PHENOMENON} text="Phenomena" />}
          <FilterRadioButton {...props} type={ModelEntityType.COMPANY} text="Companies" />
          {canSeeLegalEntities && <FilterRadioButton {...props} type="legalEntity" text="Legal entities" />}
          <FilterRadioButton {...props} type={ModelEntityType.GROUP} text="Funds or indices" />
          <FilterRadioButton {...props} type={ModelEntityType.PORTFOLIO} text="Portfolios" />
        </ButtonsPart>
      </Main>
    </Root>
  );
}

const Root = styled.div`
  ${getTextStyle({ size: 'xxs' })};
  display: block;
`;

const firstBreakpoint = 1270;

const Main = styled.div`
  border-bottom: 1px solid ${themeGet('colors.border.dark')};
  padding-bottom: 1em;
  display: flex;
  align-items: flex-start;
  @media (max-width: ${firstBreakpoint}px) {
    display: block;
  }
`;

const SearchFor = styled.div`
  margin-right: 1em;
  white-space: nowrap;
  @media (max-width: ${firstBreakpoint}px) {
    display: block;
    margin-bottom: 1em;
  }
`;

const ButtonsPart = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 1em;
  row-gap: 0.5em;
  * {
    color: ${BouColor.PLATFORM_TEXT_WHITE};
  }
`;
